import styled from 'styled-components';
import { BasicParagraph } from '~/components/common/text/BasicParagraph';
import { Achievements } from '~/features/stamps/achievements/types/enums';
import { useLocale } from '~/hooks/useLocale';
import { useTranslation } from '~/hooks/useTranslation';
import { isLocalizeKey } from '~/interfaces/i18n';
import { pxVw } from '~/styles/ts/functions';
import { path } from '~/utils/path';

type ItemList = {
  [key in Achievements]: {
    path: string;
    stamps: string[];
  };
};

const itemList: ItemList = {
  [Achievements.FootMeasurement]: {
    path: path.image('/achievement/footMeasurement.png'),
    stamps: ['measurement'],
  },
  [Achievements.FootMeasurementAndExtraBonus]: {
    path: path.image('/achievement/footMeasurementAndExtraBonus.png'),
    stamps: ['measurement', 'continuation'],
  },
  [Achievements.CreateArtwork]: {
    path: path.image('/achievement/createArtwork.png'),
    stamps: ['ashiart'],
  },
  [Achievements.PublishedGallery]: {
    path: path.image('/achievement/publishedGallery.png'),
    stamps: ['gallery'],
  },
  [Achievements.CreateArtworkAndPublishedGallery]: {
    path: path.image('/achievement/createArtworkAndPublishedGallery.png'),
    stamps: ['ashiart', 'gallery'],
  },
  [Achievements.Birthday]: {
    path: path.image('/achievement/birthday.png'),
    stamps: ['birthday'],
  },
  [Achievements.RegisterShoes]: {
    path: path.image('/achievement/registerShoes.png'),
    stamps: ['registerShoes'],
  },
};

const Container = styled.div`
  margin-bottom: ${pxVw.SP(36)};
`;

interface ImageProps {
  src: string;
}

const StampImage = styled.div<ImageProps>`
  display: block;
  width: 100%;
  margin: ${pxVw.SP(50)} auto;
  background-image: url(${({ src }) => src});
  background-position: center;
  background-repeat: no-repeat;
  height: ${pxVw.SP(340)};
  background-size: ${pxVw.SP(672)} ${pxVw.SP(340)};
`;

const MessageWrap = styled.div`
  height: ${pxVw.SP(168)};
  margin: ${pxVw.SP(40)} auto ${pxVw.SP(62)};
`;

interface Props {
  achievementType: Achievements;
}

export const AchievementModalItem = ({ achievementType }: Props) => {
  const item = itemList[achievementType];
  const { t } = useTranslation();
  const { isEnglish } = useLocale();

  const stamps = item.stamps.map((s) => {
    const _key = `stamp_type_${s}`;
    const _text = isLocalizeKey(_key) ? t(_key) : s;
    return _text.toString();
  });

  const stampText = isEnglish
    ? stamps.join(t('stamp_txt_separater').toString()) + '!'
    : stamps.map((v) => `『${v}』`).join(t('stamp_txt_separater').toString() + '');
  const _data = { stamp: stampText };

  return (
    <Container>
      <StampImage src={item.path} />
      <MessageWrap>
        <BasicParagraph
          size={isEnglish ? 40 : 32}
          weight={700}
          lineHeight={1.75}
          textAlign="center"
          wordBreak="keep-all"
        >
          {t('stamp_txt_got', _data)}
        </BasicParagraph>
      </MessageWrap>
    </Container>
  );
};
